/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskTypeEnum } from './taskTypeEnum';

export type TaskUpdateRequestType = TaskTypeEnum | null;
